package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_08_08_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes in their Freeburg bastion just after they staged an intervention to separate Bigglesworth from the cursed blade, Razorwrath. They have invited Lord Fox for dinner tonight and are considering a couple of alternative paths to Pentish for the next shard of the Shield of Concar.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Since Goram parted with the heroes on Newgrowth 78, he trained a unit for special operations and conducted a secret mission in Inan where he was ambushed by Dorvidians. He is haunted by the memory of lost comrades.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goram brought gifts for each of the heroes:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""🐟 Biggs   - A fish
🪶 Dirk    - Quill from a great eagle
💐 Caper   - Planter with exotic flowers
⛪️ Falorn  - Holy symbol
🧩 Annette - Puzzle box
🌳 Tuesday - Sapling of a Treeant
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper plants the flowers, and Tuesday leaves “Woody” in the stable to keep Aloysius company. Falorn suggests building a shrine to Entor in the bastion.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At dinner, Lord Fox seems very intent on obtaining and attuning to the curse blade, Razorwrath. He tries to suggest the heroes ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("pay him")
        }
        org.jetbrains.compose.web.dom.Text(" to investigate it and asks simple-minded Bigglesworth directly to buy it from him. Tuesday brokers a deal:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Fox receives the blade.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The bastion loan is fully paid - 30,000g value.")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("200,000g value")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("50,000g sale price")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("20,000g down payment")
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Fox will search for a replacement blade for Bigglesworth.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The remainder owed by Lord Fox will be settled in the future (estimate 270,000g minus replacement blade value).")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes add 2,500 gold to the bastion maintenance fund (overseen by Stadler Feyless).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes decide to take the path through the mountains of Ladikor on the way to Pentish. Goram speaks Dwarvish.")
    }
}
